<template>
  <v-row class="align-center">
    <v-col cols="12" class="pa-0 mb-1" v-for="(item, i) in leads" :key="'item' + i">
      <Lead :item="item" :i="i" @details="details" @rate="rate" @editDetails="editDetails" @message="message"
        @clipboardSuccessHandler="clipboardSuccessHandler" @clipboardErrorHandler="clipboardErrorHandler" />
    </v-col>
    <v-col cols="12" class="py-0" DETAILS>
      <v-dialog v-model="loading" persistent max-width="500px" transition="dialog-transition">
        <v-card color="primary" class="py-3 px-2">
          <v-progress-linear color="white" :indeterminate="true"></v-progress-linear>
        </v-card>
      </v-dialog>
    </v-col>
    <v-col cols="12" class="py-0" DETAILS>
      <v-dialog v-model="dialog" scrollable persistent :overlay="false" max-width="900px"
        transition="dialog-transition">
        <v-card>
          <v-toolbar color="white" flat dense>
            <div :class="`${arabic ? 'arFont' : 'enFont'}`">{{ i18n["order_details"] }}</div>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn text small :class="`${arabic ? 'arFont' : 'enFont'}`" @click="dialog = false">{{ i18n["close"]}}</v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text v-if="lead">
            <div :class="`${arabic ? 'arFont' : 'enFont'} mb-1`" style="font-weight:bold;">{{ i18n["basic_information"] }}</div>
            <Lead :item="lead" :embed="true" @details="details" @editDetails="editDetails"
              @clipboardSuccessHandler="clipboardSuccessHandler" @clipboardErrorHandler="clipboardErrorHandler" />
            <div :class="`${arabic ? 'arFont' : 'enFont'} my-1`" style="font-weight:bold;">{{ i18n["products"] }}</div>
            <Order :lead="lead" :order="lead.items" />
            <v-template v-if="lead.subvendor">
              <div :class="`${arabic ? 'arFont' : 'enFont'} my-1`" style="font-weight:bold;">{{ i18n["additional_fees"] }}</div>
              <Fees :item="lead" />
            </v-template>
            <div :class="`${arabic ? 'arFont' : 'enFont'} my-1`" style="font-weight:bold;">{{ i18n["order_status_followup"] }}</div>
            <Timeline :updates="lead.updates" />
            <div :class="`${arabic ? 'arFont' : 'enFont'} my-1`" style="font-weight:bold;">{{ i18n["calls_followup"] }}</div>
            <TimelineCalls :updates="lead.calls" />
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text :class="`${arabic ? 'arFont' : 'enFont'}`" @click="dialog = false">{{ i18n["close"] }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
    <v-col cols="12" class="py-0" RATE>
      <v-dialog v-model="dialog2" scrollable persistent :overlay="false" max-width="700px"
        transition="dialog-transition">
        <v-card>
          <v-toolbar color="white" flat dense>
            <div :class="`${arabic ? 'arFont' : 'enFont'}`">{{ i18n["order_id_order_rating"] }}</div>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn text small :class="`${arabic ? 'arFont' : 'enFont'}`" @click="dialog2 = false">{{ i18n["close"] }}</v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text class="text-center">
            <v-rating v-model="rating" background-color="secondary lighten-1" color="secondary" half-increments hover
              size="64">
            </v-rating>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text :class="`${arabic ? 'arFont' : 'enFont'}`" @click="dialog = false">{{ i18n["send"] }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
    <v-col cols="12" class="py-0" MESSAGE>
      <v-dialog v-model="dialog3" scrollable persistent :overlay="false" max-width="700px"
        transition="dialog-transition">
        <v-card>
          <v-toolbar color="white" flat dense>
            <div :class="`${arabic ? 'arFont' : 'enFont'}`">{{ i18n["order_number_send_message_about_order"] }}</div>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn text small :class="`${arabic ? 'arFont' : 'enFont'}`" @click="dialog3 = false">{{ i18n["close"] }}</v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text class="text-center">
            <v-textarea :class="`${arabic ? 'arFont' : 'enFont'}`" :label="i18n['message']" filled hide-details></v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text :class="`${arabic ? 'arFont' : 'enFont'}`" @click="dialog = false">{{ i18n["send"] }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
import axios from 'axios';
import Lead from './Lead';
import Order from './Order';
import Timeline from './Timeline';
import TimelineCalls from './TimelineCalls';
import Fees from './Fees';

export default {
  props: ['leads'],
  components: {
    Lead, Order, Timeline, TimelineCalls, Fees,
  },
  data() {
    return {
      dialog: false,
      dialog2: false,
      dialog3: false,
      lead: null,
      rating: 0,
      loading: false,
    };
  },
  methods: {
    clipboardSuccessHandler({ value, event }) {
      this.$emit('clipboardSuccessHandler', { value, event });
    },
    clipboardErrorHandler({ value, event }) {
      this.$emit('clipboardSuccessHandler', { value, event });
    },
    async details(i) {
      this.lead = this.leads[i];
      this.lead = await this.$store.dispatch('getResource', { resource: `/lead/${this.lead.uuid}`, page: '' });
      this.dialog = true;
    },
    favPricing(products) {
      const { state } = this.$store;
      for (let i = 0; i < products.length; i++) {
        const product = products[i];
        products[i].active_image = products[i].image;
        // console.log(product);
        const f = product.vprices.filter((x) => x.country && x.country.id === state.country.id);
        if (f.length) {
          product.price_name = f[0].name;
          product.base_price = parseFloat((parseFloat(f[0].value)).toFixed(2));
          product.price = parseFloat((parseFloat(f[0].value) * state.currency_factor).toFixed(1));
          product.base_profit = parseFloat((parseFloat(f[0].value) * 0.2).toFixed(2));
          product.profit = parseFloat((parseFloat(f[0].value) * state.currency_factor * 0.2).toFixed(1));
          product.user_base_profit = parseFloat((parseFloat(f[0].value) * 0.2).toFixed(2));
          product.user_profit = parseFloat((parseFloat(f[0].value) * state.currency_factor * 0.2).toFixed(1));
          product.currency_factor = state.currency_factor;
          // if(state.tax) {
          //   product.price = parseFloat((parseFloat(product.price) + product.price * state.tax).toFixed(1))
          // }
        }
      }
      return products;
    },
    async editDetails(i) {
      this.loading = true;
      this.$store.state.cart = [];
      this.$store.state.edit_lead = {};
      this.lead = this.leads[i];
      this.$store.state.countries = await axios.get('https://product.yervip.com/api/v1/countries-ninja').then((x) => x.data);
      this.lead = await this.$store.dispatch('getResource', { resource: `/lead/${this.lead.uuid}`, page: '' });
      const lead_country = await this.$store.dispatch('getBackResource', { resource: `/country/${this.lead.country_id}`, page: '' });
      // console.log('lead_country', lead_country);
      localStorage.country = JSON.stringify(lead_country);
      this.$store.state.country = lead_country;
      await this.$store.dispatch('manualCountry', lead_country);

      // await  this.$store.dispatch('loadCompanyCodes', lead_country)
      // console.log('edit_lead', this.lead, 'edit_lead_id', this.lead.id);

      this.$store.state.edit_lead = this.lead;
      for (let k = 0; k < this.lead.items.length; k++) {
        const item = this.lead.items[k];
        // console.log(item);
        const p = {
          ...this.favPricing([item.product])[0],
          price: parseFloat(item.price),
          profit: parseFloat(item.price) * 0.2,
          user_base_profit: parseFloat(item.user_base_profit),
          user_profit: parseFloat(item.user_profit),
          quantity: parseFloat(item.quantity),
        };
        this.$store.dispatch('addToCart', p);
        if (parseFloat(item.quantity) > 1) {
          for (let i = 0; i < parseInt(item.quantity) - 1; i++) {
            this.$store.dispatch('increaseQuantity', p);
          }
        }
      }
      this.$store.state.edit_dialog = true;
      this.loading = false;
    },
    rate(i) {
      this.lead = this.leads[i];
      this.dialog2 = true;
    },
    message(i) {
      this.lead = this.leads[i];
      this.dialog3 = true;
    },
  },
  computed: {

    api() {
      return this.$store.state.settings.apiBase;
    },
    users() {
      const sa = this.$store.state.user && this.$store.state.user.role == 'superadmin';
      // console.log(sa)
      return this.$store.state.users.filter((x) => {
        if (!sa) {
          return x.superior == this.$store.state.user.level;
        } return x;
      });
    },
    site() {
      return this.$store.state.site;
    },
    items() {
      return this.$store.state.menu;
    },
    superAdmin() {
      return this.$store.state.superAdmin;
    },
    isLogin() {
      return this.$store.state.centralLogin;
    },
    language() {
      return this.$store.state.language;
    },
    globalLoading() {
      return this.$store.state.globalLoading;
    },
    user() {
      return this.$store.state.user;
    },
    i18n() {
      return this.$store.state.i18n[this.$store.state.language];
    },
    arabic() {
      if (this.$store.state.language == 'ar') return true;
    },
    routeTitle() {
      const main = this.$store.state.menu.filter((x) => x.path == this.$route.path);
      const sub = [].concat(...this.$store.state.menu.map((x) => x.subs)).filter((x) => x).filter((x) => x.path == this.$route.path);
      if (main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text];
      } if (sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text];
      }
      return '';
    },
    roles() {
      return this.$store.state.userRoles;
    },
    notifications() {
      return this.$store.state.notifications.sort((a, b) => b.timestamp - a.timestamp);
    },
  },
};
</script>

<style>

</style>
